module.exports = __webpack_public_path__ + "static/media/vitao.d9449ec0.jpg";